import Notifications from '../argon/components/NotificationPlugin';
//import GlobalComponents from './globalComponents';
import GlobalDirectives from './globalDirectives'

export default {
    install(app) {
        app.use(Notifications);
        //app.use(GlobalComponents);
        app.use(GlobalDirectives);
    }
}